export default __webpack_public_path__ + "media/images/icons/lock-open-solid-ad5592d4211241a3f4aa9bcb692d7a85.svg";